export default function FileField({ field, onChange, error, disabled }) {
  return (
    <div className="dynamic-field-control">
      <label className="dynamic-field-control__label" htmlFor={field.key}>
        {field.label}
        {field.required && (
          <span className="dynamic-field-control__required">*</span>
        )}
      </label>

      <input
        id={field.key}
        type="file"
        disabled={disabled}
        className={`dynamic-field-control__input ${
          error ? "dynamic-field-control__input--error" : ""
        }`}
        onChange={(e) => onChange(field.key, e.target.files?.[0] || null)}
      />

      {field.help_text && (
        <p className="dynamic-field-control__help">{field.help_text}</p>
      )}
      {error && <span className="dynamic-field-control__error">{error}</span>}
    </div>
  );
}
